/**
 * @fileoverview
 * A component that displays a circular ring with three sections,
 * representing a three-step process and is used as a loading indicator.
 * @copyright ThoughtSpot Inc. 2023
 * @author Ankit Choudhary
 */
import { generateUUID } from '@thoughtspot/js-util';
import cx from 'classnames';
import React, { useEffect, useState } from 'react';
import { SafeHTML } from '../../safe-html';
import { getLoaderSvgSize, svgPaths, } from './circular-step-loader.constants';
import styles from './circular-step-loader.module.scss';
export const CircularStepLoader = ({ id, activeState, className, loadingText = '', loaderSize, hideLoader, children, ...restProps }) => {
    // Subtracting by 1 to match the array index
    const activePath = activeState - 1;
    const [loaderText, setLoaderText] = useState(loadingText);
    const loaderClassNames = cx(styles.loadingIndicatorContainer, {
        [styles.hideLoader]: hideLoader,
    }, {
        [styles.shimmerEffect]: !hideLoader,
    }, className);
    const circularLoadingIndicatorWrapper = cx(styles.loadingIndicatorLowOpacity, styles.loadingIndicator);
    useEffect(() => {
        setLoaderText(loadingText);
    }, [loaderText, loadingText]);
    const getClassnameForPath = (index) => {
        return index < activePath + 1
            ? styles.bluePrimary
            : styles.blueSecondary;
    };
    const { height, width } = getLoaderSvgSize(loaderSize);
    return (React.createElement("div", { className: loaderClassNames, id: id, "data-testid": "circular-step-loader", "data-display-name": CircularStepLoader.displayName, ...restProps },
        React.createElement("div", { className: circularLoadingIndicatorWrapper },
            loaderSize ? (React.createElement("div", { className: styles.loaderSvg, "data-testid": "svgContainer" },
                React.createElement("svg", { width: height, height: width, viewBox: "0 0 106 106", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, svgPaths.map((path, index) => (React.createElement("path", { key: generateUUID(), d: path, className: getClassnameForPath(index) })))))) : null,
            React.createElement("div", { className: styles.loadingText, "aria-hidden": true },
                React.createElement(SafeHTML, { html: loadingText }))),
        children));
};
CircularStepLoader.displayName = 'radiant_react_circular_step_loader';
//# sourceMappingURL=circular-step-loader.js.map